import { BoasVindas } from "../../../interfaces/entities/UnimedAcolhe/BoasVindas";

export const defaultWelcome: BoasVindas = {
    textos: [''],
    imagens: ['']
}